/**
 * File gallery-scripts.js.
 *
 * Handles Modal gallery page events.
 *
 */

import './vendor/carousel/carousel.min';

(function ($) {
  var $homeSlider = $('#home-slider-carousel');
  if (!$homeSlider.length) {
    return;
  }

  $homeSlider.carousel({
    autoplay: true,
    interval: 14000,
  });

  // Re-init after 7s: home preloader covers the slider for ~6s then fades 3s.
  // First init uses 14s; this restart sets 7s once the hero is visible.
  setTimeout(function () {
    $homeSlider.carousel('dispose');
    $homeSlider.carousel({
      interval: 7000,
    });
  }, 7000);
})(jQuery);

// Carousel Touch Events
(function ($) {
  var $carousels = $('.carousel');
  if (!$carousels.length) {
    return;
  }

  var touchStartX = null;

  $carousels.each(function () {
    var $carousel = $(this);
    $(this)
      .on('touchstart', function (event) {
        var e = event.originalEvent;
        if (e.touches.length == 1) {
          var touch = e.touches[0];
          touchStartX = touch.pageX;
        }
      })
      .on('touchmove', function (event) {
        var e = event.originalEvent;
        if (touchStartX != null) {
          var touchCurrentX = e.changedTouches[0].pageX;
          if (touchCurrentX - touchStartX > 60) {
            touchStartX = null;
            $carousel.carousel('prev');
          } else if (touchStartX - touchCurrentX > 60) {
            touchStartX = null;
            $carousel.carousel('next');
          }
        }
      })
      .on('touchend', function () {
        touchStartX = null;
      });
  });
})(jQuery);

// Modal Carousel
(function ($) {
  let $imgClick = $('.gallery__section--content--showImages--container--link'),
    $modalGallery = $('#loadModal-gallery'),
    $closeButton = $('.modal-gallery__container--inner--btn--close'),
    $carouselInner = $('#loadModal-gallery .carousel-inner'),
    $carouselNext = $('.carousel-control-next'),
    $carouselPrev = $('.carousel-control-prev');

  if (!$modalGallery.length || !$imgClick.length) {
    return;
  }

  $imgClick.on('click', function (e) {
    // Show modal gallery
    $modalGallery.fadeIn('slow');

    // Get Active image url from the data source
    let $activeUrl = $(this).data('url');

    // Get gallery id from the data source
    let $galleryID = $(this).data('gallery');

    // Get all element for that gallery
    let arrayElements = document.querySelectorAll(
      '[data-gallery =' + $galleryID + ']'
    );

    // Set gallery items via DOM APIs (do not concatenate URLs into HTML).
    arrayElements.forEach(function (value) {
      let imgUrl = value.getAttribute('data-url');
      if (!imgUrl) {
        return;
      }

      const item = document.createElement('div');
      item.className = 'carousel-item';
      if ($activeUrl == imgUrl) {
        item.classList.add('active');
      }

      const img = document.createElement('img');
      img.className = 'd-block w-100';
      img.src = imgUrl;
      img.alt = 'image slide';
      item.appendChild(img);

      $carouselInner.each(function () {
        this.appendChild(item.cloneNode(true));
      });

      if ($activeUrl == imgUrl) {
        // Show the carousel next, prev and close links
        setTimeout(function () {
          $carouselNext.toggleClass('show-item-now');
          $carouselPrev.toggleClass('show-item-now');
          $closeButton.toggleClass('show-item-now');
        }, 500);
      }
    });
  });

  // Init Carousel (gallery lightbox only — do not reset the home slider)
  $('#modal-gallery-carousel').carousel({
    pause: true,
    interval: false,
    wrap: true,
  });

  // Close modal
  $closeButton.on('click', function () {
    $modalGallery.fadeOut('slow');
    $carouselNext.toggleClass('show-item-now');
    $carouselPrev.toggleClass('show-item-now');
    $closeButton.toggleClass('show-item-now');
    setTimeout(function () {
      $carouselInner.empty();
    }, 800);
  });
})(jQuery);
